import script from "./SubPaymentHistoryTable.vue?vue&type=script&setup=true&lang=js"
export * from "./SubPaymentHistoryTable.vue?vue&type=script&setup=true&lang=js"

import "./SubPaymentHistoryTable.vue?vue&type=style&index=0&id=48ff5939&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48ff5939"]])

export default __exports__